<div class="login-container h-full">
  <div class="absolute inset-0 opacity-10 bg-[url('/assets/images/login/login-background.jpg')] bg-cover bg-center"></div>

  <div class="grid relative place-items-center p-4 md:p-12 h-full">
    <div
      id="loginCard"
      class="w-full max-w-[920px] grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] rounded-[22px] overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.35)] border border-border-panel backdrop-blur-2xl"
    >
      <!-- Left Side - Login Form -->
      <div class="flex flex-col justify-between p-7 left-side-style">
        <div>
          <!-- card Header -->
          <div class="flex items-center gap-3.5">
            <img src="assets/images/logo.png" alt="MBLE Logo" class="h-14 w-auto drop-shadow-[0_6px_18px_rgba(46,115,247,0.35)]" />
            <div>
              <h1 class="font-bold leading-none text-text-primary tracking-wide m-0">MES</h1>
              <p class="text-text-muted">Manufacturing Execution Platform</p>
            </div>
          </div>

          <!-- Login Form -->
          <form [formGroup]="loginForm" class="flex flex-col py-12">
            <!-- QR Token Field -->
            <div class="mt-4">
              <div class="flex items-center justify-between mb-2">
                <label for="qrToken" class="ml-0.5 font-semibold text-text-primary">QR-Token</label>
                <button
                  type="button"
                  (mousedown)="$event.preventDefault()"
                  (click)="toggleScanner()"
                  class="flex items-center gap-1.5 text-xs font-semibold border text-white border-white/40 rounded-lg px-2.5 py-1.5 hover:bg-primary/10 transition-colors duration-150"
                >
                  <span class="material-icons text-base leading-none">qr_code_2</span>
                  {{ showScanner ? 'Scanner schließen' : 'QR-Code scannen' }}
                </button>
              </div>
              <div class="relative">
                <input
                  type="password"
                  id="qrToken"
                  #qrTokenInput
                  formControlName="qrToken"
                  placeholder="QR-Token scannen"
                  autocomplete="off"
                  data-cy="login-qr-token"
                  class="w-full py-2.5 px-3.5 rounded-xl bg-glass border border-border-glass text-text-primary outline-none transition-all duration-200 placeholder:text-[#a8b6cc] focus:border-primary focus:shadow-[0_0_0_3px_rgba(46,115,247,0.22)]"
                  [ngClass]="{
                    'border-red-500 focus:border-red-500 focus:shadow-[0_0_0_3px_rgba(239,68,68,0.22)]':
                      loginForm.get('qrToken')?.invalid && loginForm.get('qrToken')?.touched,
                  }"
                />
                @if (loginForm.get('qrToken')?.invalid && loginForm.get('qrToken')?.touched) {
                  <div class="absolute -bottom-4 left-0 text-xs text-red-500" data-cy="qr-token-error">
                    {{ getErrorMessage('qrToken') }}
                  </div>
                }
              </div>
            </div>

            <!-- Submit Button -->
            <div class="mt-5">
              <button
                type="submit"
                data-cy="login-submit"
                (click)="onSubmit()"
                [disabled]="isLoading"
                class="w-full py-2.5 px-4 rounded-[14px] bg-primary text-white font-bold tracking-wide border border-transparent cursor-pointer transition-all duration-200 hover:brightness-105 active:translate-y-px disabled:cursor-not-allowed disabled:opacity-50 flex items-center justify-center gap-2.5"
              >
                @if (isLoading) {
                  <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none" />
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                  <span>Anmelden...</span>
                } @else {
                  <span>Anmelden</span>
                }
              </button>
            </div>
          </form>
        </div>

        <!-- Footer -->
        <div class="mt-5 text-[12px] text-[#8ea4c3]">&copy; {{ currentYear }} MBLE – Interne Anwendung</div>
      </div>

      <!-- Right Side - Visual Art Panel -->
      <div class="right-side-style hidden lg:block relative overflow-hidden p-7">
        <!-- Badge -->
        <span class="absolute top-5 left-5 py-1.5 px-3 rounded-full bg-white/10 border border-border-glass text-[12px] text-[#e7f0ff]">
          ISO-Zertifiziert• ISO 9001/14001
        </span>

        <!-- Glass Card with Images -->
        <div
          class="absolute inset-x-6 bottom-6 bg-white/10 backdrop-blur-xl border border-glass-strong rounded-2xl p-4 shadow-[0_20px_60px_rgba(0,0,0,0.35)]"
        >
          <div class="grid grid-cols-2 gap-2.5">
            <img src="assets/images/login/example-bg.png" class="w-full h-[120px] object-cover rounded-xl border border-white/15" />
            <img src="assets/images/login/mble-bauteilvorbereitung.png" class="w-full h-[120px] object-cover rounded-xl border border-white/15" />
            <img src="assets/images/login/mble-fertigung-smd-gurtung.png" class="w-full h-[120px] object-cover rounded-xl border border-white/15" />
            <img
              src="assets/images/login/mble-fertigung-radialgurtung-3.png"
              class="w-full h-[120px] object-cover rounded-xl border border-white/15"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (showScanner) {
  <app-qr-code-scanner (scanSuccess)="onScanSuccess($event)" (closed)="onScannerClosed()"></app-qr-code-scanner>
}
